export default __webpack_public_path__ + "static/media/video-preview.bbcb3e74.png";